import { useState, useRef } from "react";
import { Col, message, Row } from "antd";
import { useHistory, useParams } from "react-router-dom";

import Table from "@components/Table";
import AddIndustry from "./AddIndustry";
import Button from "@components/Button";
import { IIndustry } from "@types";
import { useDeleteIndustryMutation, useFetchIndustriesQuery } from "@services";
import { checkPermission } from "@utils";
import { permissions } from "@router";
import { getColumns } from "./config";
import customErrorMessage from "@/components/CustomErrorMessage";

const Industry = () => {
  const history = useHistory();
  let industry_id = useRef<any>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState<IIndustry | null>(
    null
  );
  const [page, setPage] = useState(1);
  const { sector_id: id } = useParams<{ sector_id: string }>();
  const { data, isLoading, refetch } = useFetchIndustriesQuery({ id, page });
  const [deleteIndustry, { isLoading: isDeleting }] =
    useDeleteIndustryMutation();
  const { data: industries, pagination } = data || {};

  const onRowClick = (data: any) => {
    history.push(`/sectors/${id}/${data?.id}`);
  };

  const editIndustry = (
    industry: IIndustry,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setSelectedIndustry(industry);
    setIsVisible(true);
  };

  const handleDeleteIndustry = async (
    id: number,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    industry_id.current = id;
    try {
      await deleteIndustry({ id });
      refetch();
      message.success("Industry deleted successfully!");
    } catch (err: any) {
      customErrorMessage("Could not delete industry.");
      console.log(err);
    }
  };

  const columns = getColumns({
    isDeleting,
    industry_id,
    editIndustry,
    handleDeleteIndustry,
  });

  return (
    <>
      {isVisible ? (
        <AddIndustry
          selectedIndustry={selectedIndustry}
          setSelectedIndustry={setSelectedIndustry}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          refetchIndustries={refetch}
        />
      ) : null}
      <div className="appTitle text-base font-[500] mx-5">
        <span
          className="cursor-pointer"
          onClick={() => history.push("/sectors")}
        >
          {" "}
          Sectors
        </span>{" "}
        {">"} Industry
      </div>
      <div className="jobCreationBar  sticky top-0 z-10 bg-white px-14 py-6 rounded-lg flex justify-between items-center my-7">
        <div className="title text-themeBlue font-[500] text-3xl">
          Sectors, Industry & Sub-Industry
        </div>
        <div className="action-buttons flex items-center gap-2">
          {checkPermission(permissions.CREATE_INDUSTRY) && (
            <Button variant="add" onClick={() => setIsVisible(true)}>
              Add Industry
            </Button>
          )}
        </div>
      </div>
      <div className=" bg-white px-14 py-6 rounded-lg">
        <Table
          onRowClick={onRowClick}
          data={industries}
          columns={columns}
          isLoading={isLoading}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          page={page}
        />
      </div>
    </>
  );
};

export default Industry;
